import { removeDocumentsFromResource } from 'common/form/DocumentUploader/actions';
import { REMOVE_CONTACT_DOCUMENT_FROM_RESOURCES } from 'actions';

function removeDocumentFromContactResources({
  contactId,
  documentId,
  addToast,
}) {
  const request = removeDocumentsFromResource({
    documentId,
    resourceId: contactId,
    resourceType: 'person',
  });
  return (dispatch) => {
    function onSuccess(payload) {
      dispatch({
        type: REMOVE_CONTACT_DOCUMENT_FROM_RESOURCES,
        contactId,
        documentId,
        payload,
        resourceIds: documentId,
      });

      if (addToast) {
        addToast({
          message: 'Document removed',
          type: 'success',
        });
      }

      return payload;
    }
    function onError(error) {
      if (addToast) {
        addToast({
          message: 'Document couldn\'t be removed',
          type: 'error',
        });
      }
      return error;
    }
    return request.then(onSuccess, onError);
  };
}

export default removeDocumentFromContactResources;
